import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";
import GradientButton from "../../../../components/buttons/gradientButton/GradientButton";
import QuantitySelector from "../../../../components/marketplace/QuantitySelector/QuantitySelector";
import { addItemToRequest } from "../../../../redux/marketplaceRequest/reducer";
import { getRequestItems } from "../../../../redux/marketplaceRequest/reducer";
import { PLACEHOLDER_IMAGES } from "../../../../utility/placeholders";
import "./ProductModal.scss";

const ProductModal = ({ product, provider, onClose }) => {
  const [quantity, setQuantity] = useState(1);
  const { t } = useTranslation("marketplace");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const alert = useAlert();
  const items = useSelector(getRequestItems);
  const itemInCart = items.find((i) => i.id === product.id);

  const handleAddToRequest = () => {
    if (itemInCart) {
      alert.show(t("provider.product_already_in_cart"), { type: "info" });
      onClose();
      return;
    }

    dispatch(
      addItemToRequest({
        providerId: provider.id,
        providerName: provider.name,
        providerMessage: provider.message,
        item: product,
        quantity,
      }),
    );
    onClose();
  };

  const handleRedirectToWebsite = () => {
    if (provider.redirectionUrl) {
      window.open(provider.redirectionUrl, "_blank");
      onClose();
    }
  };

  const handleViewRequest = () => {
    onClose();
    navigate("/dashboard/marketplace-cart");
  };

  const hasRedirectionUrl = provider.redirectionUrl;
  const hasQuantitySelector = itemInCart
    ? itemInCart.hasQuantitySelector
    : product.quantity !== false;

  return (
    <Modal show onHide={onClose} centered size="lg" dialogClassName="product-modal">
      <Modal.Header closeButton />

      <Modal.Body className="product-modal__body">
        <div className="product-modal__card">
          <div className="product-modal__image">
            <img
              src={product.imageUrl}
              alt={product.name}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = PLACEHOLDER_IMAGES.PRODUCT;
              }}
            />
          </div>

          <div className="product-modal__info">
            <span className="product-modal__provider">{provider.name}</span>
            <h2 className="product-modal__name">{product.name}</h2>
            <p className="product-modal__desc">{product.description}</p>
            <div className="product-modal__hint">
              {hasRedirectionUrl
                ? t("provider.external_hint", {
                    defaultValue:
                      "Ce fournisseur finalise les demandes depuis son propre site web.",
                  })
                : t("provider.request_hint", {
                    defaultValue:
                      "Cet article sera ajouté à votre demande. Le fournisseur ou Comitty reviendra vers vous.",
                  })}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="product-modal__footer">
        {!hasRedirectionUrl && hasQuantitySelector && (
          <div className="product-modal__qty">
            <QuantitySelector value={quantity} onChange={setQuantity} />
          </div>
        )}

        <div className="product-modal__add-btn">
          <GradientButton
            onPress={itemInCart ? handleViewRequest : hasRedirectionUrl ? handleRedirectToWebsite : handleAddToRequest}
          >
            {itemInCart
              ? t("provider.view_request", { defaultValue: "Voir ma demande" })
              : hasRedirectionUrl
                ? t("provider.redirect_to_website")
                : t("provider.add_to_request")}
          </GradientButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductModal;
